import React from 'react';
import { Item } from './styles';
import { formatTimestamp, formatValue } from './utils';

export default function Motor({ data }) {
  if (!data) return null;

  return (
    <Item>
      <h3 style={{ marginBlockEnd: 0 }}>Motor</h3>
      {Object.entries(data).map(([sensor_id, d]) => (
        <div key={d.id || d.timestamp}>
          {formatTimestamp(d.timestamp)}{d.frequency && <> - {formatValue(d.frequency, 1)} Hz</>}
          <p style={{ marginLeft: '1em' }}>
            Control value: {formatValue(d.control_value)}<br />
            Rotations: {formatValue(d.rotations)}<br />
            RPM: {formatValue(d.rpm)}<br />
            Torque: {formatValue(d.torque)} Nm<br />
            Damping: {d.rpm !== 0 ? formatValue(-d.torque / d.rpm) : "-"}<br />
            Temperature: {formatValue(d.temperature, 0)} °C<br />
            {d.error && <>Error: {d.error}<br /></>}
          </p>
        </div>
      ))}
    </Item>
  );
}
